import { render, staticRenderFns } from "./joinclazzreview.vue?vue&type=template&id=20eee4b1&scoped=true&"
import script from "./joinclazzreview.vue?vue&type=script&lang=js&"
export * from "./joinclazzreview.vue?vue&type=script&lang=js&"
import style0 from "./joinclazzreview.vue?vue&type=style&index=0&id=20eee4b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eee4b1",
  null
  
)

export default component.exports